import { z } from 'zod';

import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const EvaluatablePluginWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.EvaluatablePlugin).extend({
  pluginId: z.string(),
  // Written by the drag-and-drop plugin (the Edgy wizard's model); other plugins do not carry it. Declared so
  // the parsed static content keeps it for the xAPI matching adapter.
  preset: z.string().optional()
});

export type EvaluatablePluginWidgetStaticSchemaType = z.infer<typeof EvaluatablePluginWidgetStaticSchema>;
